import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, Typography, Box, Alert } from '@mui/material';
import { Sparkles } from 'lucide-react';
import toast from 'react-hot-toast';
import { tokens } from '@/theme/tokens';
import { leaveRequestsApi } from '@/api/leaveRequests.api';

export function InitializeLeaveModal({ open, onClose, onSuccess }) {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const yearOptions = [currentYear - 1, currentYear, currentYear + 1, currentYear + 2];

  const handleInitialize = async () => {
    setLoading(true);
    setErrorMsg('');
    try {
      await leaveRequestsApi.initializeBalance(Number(year));
      toast.success(`Leave quotas successfully initialized for year ${year}!`);
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      const msg =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        err.message ||
        'Failed to initialize leave balances';
      setErrorMsg(typeof msg === 'string' ? msg : 'Failed to initialize leave balances');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: tokens.radius.card,
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>
        Initialize Leave Balances
      </DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 2 }}>
        {errorMsg && <Alert severity="error">{errorMsg}</Alert>}

        <Typography variant="body2" color="text.secondary">
          Select the academic year to initialize annual leave quotas and balances for all active staff members based on active Leave Types.
        </Typography>

        <TextField
          select
          label="Target Year"
          value={year}
          onChange={(e) => setYear(e.target.value)}
          fullWidth
          size="small"
        >
          {yearOptions.map((y) => (
            <MenuItem key={y} value={y}>
              {y}
            </MenuItem>
          ))}
        </TextField>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={loading} variant="outlined">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          startIcon={<Sparkles size={18} />}
          onClick={handleInitialize}
          disabled={loading}
        >
          {loading ? 'Initializing...' : 'Confirm & Initialize'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
